<template>
  <div class="box-card app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 物资类别 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资类别">
            <el-input
              v-model="queryParams.categoryName"
              placeholder="请输入物资类别"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <!-- 物资名称 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.materialName"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 入库时间 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="入库时间">
            <el-date-picker
              v-model="queryParams.inDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button @click="exportExcel">导出</el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
      :data="tableData"
      style="width: 100%"
      border
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column prop="foodCategory" label="物资类别" />
      <el-table-column prop="foodMaterialName" label="物资名称" />
      <el-table-column prop="unit" label="单位" />
      <el-table-column prop="amount" label="采购总金额" />
      <el-table-column prop="quantity" label="采购总数量" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { getStockInStatisticExport, getStockInStatistic } from "@/api/material";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile, parseDateRange } from "@/utils/util";

export default {
  name: "FoodMaterialTab",
  components: {
    PaginationBar,
  },
  data() {
    return {
      totalAmount:0,
      total: 0,
      viewTotal: 0,
      viewDialogVisible: false,
      viewForm: [],
      viewId: "", //查看的ID
      viewPageSize: 5, // 查看弹窗分页大小
      viewCurrentPage: 1, // 查看弹窗当前页
      viewColumns: [
        { label: "商品类型", prop: "categoryName" },
        { label: "物资名称", prop: "name" },
        { label: "单位", prop: "unit" },
        { label: "数量", prop: "num" },
        { label: "结算单价(元)", prop: "singlePrice" },
        { label: "金额", prop: "totalAmount" },
      ],
      tableData: [],
      queryParams: {
        categoryName: "",
        materialName: "",
        inDateRange: [],
      },
      pageSize: 10,
      currentPage: 1,
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    // 合计行计算方法 - 使用后端返回的合计值
    getSummaries(param) {
      const { columns } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (column.property === "amount") {
          // 使用后端返回的总金额
          sums[index] = this.totalAmount.toFixed(2);
        } else if (column.property === "quantity") {
          // 使用后端返回的总数量
          sums[index] = this.totalCount;
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    // 重置
    resetQuery() {
      this.queryParams = {
        categoryName: "",
        materialName: "",
        inDateRange: [],
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      // 手动从日期范围数组中提取开始和结束日期
      let startDate = null;
      let endDate = null;

      if (
        this.queryParams.inDateRange &&
        this.queryParams.inDateRange.length === 2
      ) {
        startDate = this.queryParams.inDateRange[0]; // 开始日期
        endDate = this.queryParams.inDateRange[1]; // 结束日期
      }

      // 根据查询条件获取数据
      getStockInStatistic({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryName: this.queryParams.categoryName,
        materialName: this.queryParams.materialName,
        startDate: startDate,
        endDate: endDate,
      }).then((res) => {
        this.tableData = res.pageResult.records || [];
        this.total = res.pageResult.total || 0;

        // 保存后端返回的合计数据
        this.totalCount = res.sumResult.totalCount || 0;
        this.totalAmount = res.sumResult.totalAmount || 0;
      });
    },
    fetchViewData(page) {
      this.viewCurrentPage = page;
      this.handleGetView();
    },
    exportExcel() {
      let startDate = null;
      let endDate = null;

      if (
        this.queryParams.inDateRange &&
        this.queryParams.inDateRange.length === 2
      ) {
        startDate = this.queryParams.inDateRange[0]; // 开始日期
        endDate = this.queryParams.inDateRange[1]; // 结束日期
      }
      // 导出功能
      getStockInStatisticExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryName: this.queryParams.categoryName,
        materialName: this.queryParams.materialName,
        startDate: startDate,
        endDate: endDate,
      }).then((res) => {
        downloadFile(
          res.data,
          "食材物资详情记录.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
.summary-cell {
  text-align: center !important;
}
/* 使用深度选择器确保样式生效 */
.summary-cell ::v-deep td {
  text-align: center !important;
}

/* 合计行单元格居中 - 使用深度选择器 */
::v-deep .el-table__footer-wrapper .el-table__footer-cell {
  text-align: center !important;
}

/* 或者更具体的选择器 */
::v-deep .el-table .el-table__footer-wrapper td {
  text-align: center !important;
}
</style>
